export default __webpack_public_path__ + "static/secure-illustration-1f3c46b6878a253dae6b43e0b77d8d01.svg";